import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const ItemList = styled.ul``;
export const Item = styled.li``;

export const StepWrap = styled.div`
  padding: 40px 30px 30px 30px;
`;

export const StepHeader = styled.div`
  display: block;
  align-items: flex-end;
  margin-bottom: 30px;

  ${media.tabletP`
    display: flex;
  `};
`;

export const StepTitleWrap = styled.div`
  width: 100%;

  ${media.tabletP`
    width: 50%;
  `};
`;

export const StepPowerWrap = styled.div`
  width: 100%;

  ${media.tabletP`
    width: 50%;
  `};
`;

export const StepTitle = styled.h2`
  font-size: 18px;
  color: #000;
  line-height: 1.5;

  ${media.tabletP`
    font-size: 22px;
  `};
`;

export const StepProgram = styled.div`
  color: #000;
  font-size: 12px;

  .title {
    font-weight: bold;
    display: inline-block;
  }
  .caption {
    display: inline-block;
    margin-left: 5px;
  }
`;

export const StepList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StepListItem = styled.div`
  width: 50%;
  margin-right: 0;
  margin-top: 15px;
  padding-right: 12px;
  box-sizing: border-box;
  font-size: 10px;
  color: #000;
  line-height: 1.5;
  text-align: center;
  position: relative;

  ${media.tabletP`
    width: 100px;
    margin-right: 12px;
    padding-right: 0;
    font-size: 12px;
  `};

  &:after {
    content: '';
    display: none;
    position: absolute;
    top: 3px;
    right: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 8.7px;
    border-color: transparent transparent transparent #cccccc;

    ${media.tabletP`
      display: block;
    `};
  }

  &:nth-child(6n) {
    margin-right: 0;
    &:after {
      display: none;
    }
  }

  &:last-child {
    margin-right: 0;
    &:after {
      display: none;
    }
  }

  img {
    max-width: 100%;
  }

  .step {
  }

  .image {
    width: 76px;
    height: 76px;
    overflow: hidden;
    margin: 10px auto;
  }

  .text {
    text-align: left;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/DiagnosisResultStepCard/DiagnosisResultStepCard.style.js